import type { SVGProps } from 'react'
import { Ref, forwardRef } from 'react'
import { createIcon } from '../../create-icon'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgCross1 = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.7105 3.04376C13.9187 2.83548 13.9187 2.49779 13.7105 2.28952C13.5022 2.08123 13.1645 2.08123 12.9562 2.28952L8 7.24572L3.04379 2.28952C2.83551 2.08123 2.49782 2.08123 2.28955 2.28952C2.08126 2.49779 2.08126 2.83548 2.28955 3.04376L7.24575 7.99997L2.28955 12.9561C2.08126 13.1645 2.08126 13.5022 2.28955 13.7105C2.49782 13.9187 2.83551 13.9187 3.04379 13.7105L8 8.75422L12.9562 13.7105C13.1645 13.9187 13.5022 13.9187 13.7105 13.7105C13.9187 13.5022 13.9187 13.1645 13.7105 12.9561L8.75425 7.99997L13.7105 3.04376Z"
    />
  </svg>
)
const ForwardRef = forwardRef(SvgCross1)
const IconSvgCross1 = createIcon(ForwardRef, 'SvgCross1')
export default IconSvgCross1
